import { INTERVALS } from "./constants";

import { SLOT_TIME_FORMAT_24H } from "../Form/constants";

export class DayjsRange {
  constructor(startDate, endDate) {
    const { s, e } =
      startDate > endDate
        ? { s: endDate, e: startDate }
        : { s: startDate, e: endDate };

    this.startDate = s;
    this.endDate = e;
  }

  isValidRange() {
    return this.startDate.isValid() && this.endDate.isValid();
  }

  isOverlap(other) {
    if (!(other instanceof DayjsRange) || !other.isValidRange()) {
      return false;
    }

    return this.startDate < other.endDate && this.endDate > other.startDate;
  }

  toArrayOfTimeIntervals(interval = 15) {
    let startTime = this.startDate;
    const endTime = this.endDate.add(1, "days");
    const allTimes = [];

    while (startTime < endTime) {
      allTimes.push(startTime.format(SLOT_TIME_FORMAT_24H));
      startTime = startTime.add(interval, "minutes");
    }

    return allTimes;
  }
}

export default (_, __, d) => {
  d.range = (start, end) => new DayjsRange(d(start), d(end));
};

export function extendDayjs(dayjs) {
  dayjs.range = function range(start, end) {
    const dayjsObject = this;

    if (typeof start === "string" && INTERVALS.includes(start)) {
      return new DayjsRange(
        dayjs(dayjsObject).startOf(start),
        dayjs(dayjsObject).endOf(start)
      );
    }

    return new DayjsRange(start, end);
  };

  dayjs.range.constructor = DayjsRange;

  // Returns timeIntervals in 12 hour clock format for the whole day with both AM or PM suffixed
  dayjs.timeIntervalsForDay = interval => {
    const [startOfDay, endOfDay] = [
      dayjs().startOf("day"),
      dayjs().startOf("day"),
    ];

    return dayjs.range(startOfDay, endOfDay).toArrayOfTimeIntervals(interval);
  };

  return dayjs;
}
